import questionTypes from '../questionTypes';

import getCommonBlockProps from './getCommonBlockProps';
import { STYLING_KEY_STATIC_TEXT } from '../../constants/stylingKey';

export default {
  type: questionTypes.staticText,
  getDefaultProps: () => ({
    ...getCommonBlockProps(),
  }),
  settings: {
    defaultStylingEntity: STYLING_KEY_STATIC_TEXT,
    isRequiredField: () => false,
    isUniqueField: () => false,
    isTextRequired: () => true,
    maximumCharacters: 200,
  },
};
